import React from "react";
import { useUserUiPreferences } from "./useUserUiPreferences.js";

export default function useRouteMapGroupRangePreference() {
  const {
    routeMapGroupRangesVisible: showGroupedStopRangeLabels,
    setRouteMapGroupRangesVisible,
  } = useUserUiPreferences();

  const setShowGroupedStopRangeLabels = React.useCallback((value) => {
    try {
      const operation = setRouteMapGroupRangesVisible(value, { immediate: true });
      if (operation && typeof operation.catch === "function") {
        void operation.catch(() => {});
      }
    } catch {
      // Le fournisseur global rétablira la dernière préférence synchronisée.
    }
  }, [setRouteMapGroupRangesVisible]);

  return {
    setShowGroupedStopRangeLabels,
    showGroupedStopRangeLabels,
  };
}
